import { render, staticRenderFns } from "./Event.vue?vue&type=template&id=0c1fc62e&scoped=true&"
import script from "./Event.vue?vue&type=script&lang=js&"
export * from "./Event.vue?vue&type=script&lang=js&"
import style0 from "./Event.vue?vue&type=style&index=0&id=0c1fc62e&lang=scss&scoped=true&"
import style1 from "./Event.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1fc62e",
  null
  
)

export default component.exports